import { isPersonalizationOptInEnabled } from '@/app-shell/flags/growth-flags';
import { type getCurrentUser } from '@/hooks/query/useQueryUser';

/**
 * Single source of truth for the personalisation opt-in gate. Returns `true`
 * when personalisation work (apply + learn) is allowed for `user`.
 *
 * Returns `true` when the opt-in flag is off (the gate is inert for
 * out-of-cohort users and the existing pre-rollout behaviour is preserved).
 * When the flag is on, requires an explicit `personalization_opted_in === true`
 * on the user. Strict equality means `undefined` / `null` / missing
 * `session_settings` / missing user all fail closed.
 */
export const isPersonalizationGateOpen = (
  user: ReturnType<typeof getCurrentUser>
): boolean => {
  if (!isPersonalizationOptInEnabled()) return true;
  return user?.session_settings?.personalization_opted_in === true;
};
